import React from "react";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";

function MedicalServices() {
  return (
    <div>
      <PosterOne img={aboutbanner} title={"Services"} />
      <h1>MedicalServices</h1>
      <h2>MedicalServices</h2>
      <h3>MedicalServices</h3>
    </div>
  );
}

export default MedicalServices;
